/* Product page: show the Description as a full-width section under the product (always open, no arrow). */
(function () {
  try {
    var main = document.querySelector('section.product');
    var item = main && main.querySelector('.accordions .accordion-item');
    if (!item || document.querySelector('.pdesc')) return;
    var panel = item.querySelector('.accordion-panel');
    var html = panel ? panel.innerHTML.trim() : '';
    item.parentNode.removeChild(item);
    if (!html) return;
    var css = document.createElement('style');
    css.textContent = '.pdesc{padding-top:10px;padding-bottom:36px}.pdesc-card{background:#fff;border:1px solid var(--line,#E3ECF6);border-radius:24px;padding:34px 36px;box-shadow:0 20px 40px -30px rgba(0,64,224,.35)}.pdesc h2{font-size:clamp(1.5rem,3vw,2rem);margin:0 0 16px}.pdesc-body{color:var(--ink,#000);line-height:1.75;font-size:1.05rem;max-width:none}.pdesc-body img{max-width:100%;height:auto}@media(max-width:860px){.pdesc{padding-left:12px;padding-right:12px}.pdesc-card{padding:22px 18px;border-radius:18px}}';
    document.head.appendChild(css);
    var sec = document.createElement('section');
    sec.className = 'wrap pdesc';
    sec.innerHTML = '<div class="pdesc-card"><h2>Description</h2><div class="pdesc-body">' + html + '</div></div>';
    var host = main.closest('.shopify-section') || main;
    host.parentNode.insertBefore(sec, host.nextSibling);
  } catch (e) {}
})();

/* Keeps the product-page price in sync with the selected option (variant). */
(function () {
  var select = document.getElementById('product-variant-select');
  var handle = document.body.getAttribute('data-product-handle');
  if (!select || !handle) return;

  function fmt(cents) {
    var f = window.moneyFormat || '€{{amount}}';
    var n = (cents / 100);
    function withDelims(num, thousands, decimal) {
      var s = num.toFixed(2).split('.');
      s[0] = s[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return s[0] + decimal + s[1];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return withDelims(n, ',', '.');
        case 'amount_no_decimals': return String(Math.round(n)).replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        case 'amount_with_comma_separator': return withDelims(n, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return String(Math.round(n)).replace(/(\d)(?=(\d{3})+$)/g, '$1.');
        case 'amount_with_apostrophe_separator': return withDelims(n, "'", '.');
        case 'amount_with_space_separator': return withDelims(n, ' ', ',');
        default: return withDelims(n, ',', '.');
      }
    });
  }

  var product = null;
  function load() {
    if (product) return Promise.resolve(product);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { product = p; return p; });
  }

  function targets() {
    var list = [];
    var main = document.querySelector('section.product .price');
    if (main) list.push(main);
    document.querySelectorAll('.sticky-buy .price').forEach(function (el) { list.push(el); });
    return list;
  }

  function update() {
    var id = String(select.value);
    load().then(function (p) {
      var v = null;
      for (var i = 0; i < p.variants.length; i++) { if (String(p.variants[i].id) === id) { v = p.variants[i]; break; } }
      if (!v) return;
      var html = fmt(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) html += '<s>' + fmt(v.compare_at_price) + '</s>';
      targets().forEach(function (el) { el.innerHTML = html; });
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }).catch(function () {});
  }

  select.addEventListener('change', update);
})();
